module.exports = __webpack_public_path__ + "media/3.3aa6db58.wav";